import { Typography, TypographyProps } from "@mui/material";

const SpanTypography = (props: TypographyProps) => (
  <Typography component="span" {...props} />
);

export default SpanTypography;
